import { useCallback, useEffect, useState } from 'react';
import { LiraContainerIds } from '@client/components/Adv/Lira/liraContainerIds';
import { useViewport } from '@sbt-web/hooks';

const SESSION_STORAGE_KEY = 'clickInterstitialCounter';

export const useLiraLazyInterstitialForDesktop = (): (() => void) => {
  const { isDesktop } = useViewport();
  const [clickInterstitialCounter, setClickInterstitialCounter] =
    useState<number>(() => {
      if (typeof window !== 'undefined') {
        return Number.parseInt(
          sessionStorage.getItem(SESSION_STORAGE_KEY) ?? '0',
          10
        );
      }
      return 0;
    });

  const handleItemClick = useCallback(() => {
    setClickInterstitialCounter((prevCounter) => prevCounter + 1);
  }, []);

  useEffect(() => {
    sessionStorage.setItem(
      SESSION_STORAGE_KEY,
      clickInterstitialCounter.toString()
    );

    if (isDesktop && clickInterstitialCounter >= 3) {
      window.liraSDKQueue?.push(() => {
        window.liraSdk?.fetchLazyLoadAd([
          LiraContainerIds.listing.interstitialLazy,
        ]);
      });
    }
  }, [clickInterstitialCounter, isDesktop]);

  return handleItemClick;
};
